import { createSlice } from "@reduxjs/toolkit";

const initialUniState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  uniGalleryForEdit: undefined,
  error: null,
  statusOverview: {},
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const uniGallerySlice = createSlice({
  name: "uniGallery",
  initialState: initialUniState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getuniGalleryById
    uniGalleryFetched: (state, action) => {
      state.actionsLoading = false;
      state.uniGalleryForEdit = action.payload.uniGalleryForEdit;
      state.error = null;
    },

    // finduniGallery
    allUniGalleryFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    // createuniGallery
    uniGalleryCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload);
    },

    // updateuniGallery
    uniGalleryUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
    },

    // deleteuniGallery
    uniGalleryDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.uniGalleryId !== action.payload.id
      );
    },

    // deleteuniGallery
    uniGalleryHardDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.uniGalleryId !== action.payload.id
      );
    },
  },
});
